import { BiCheck } from "react-icons/bi";

const Services = () => {
  return (
    <section id="services">
      <h5>What I Offer</h5>
      <h2>Services</h2>

      <div className="container services_container">
        <article className="service">
          <div className="service_head">
            <h3>UI/UX Design</h3>
          </div>
          <ul className="service_list">
            <li>
              <BiCheck className="service_list-icon" />
              <p>Designing UI elements and tools.</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>create products with a good user experience.</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Good communication skills with UI UX Design.</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>
                Investigating user experience design requirements for your suite
                of digital assets.
              </p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>
                navigation menus, search boxes, tabs, and widgets for your
                digital assets.
              </p>
            </li>
          </ul>
        </article>
        <article className="service">
          <div className="service_head">
            <h3>Web Development</h3>
          </div>
          <ul className="service_list">
            <li>
              <BiCheck className="service_list-icon" />
              <p>Develop new user-facing features.</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Responsive Web Design.</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Basic understanding of server-side.</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Build reusable code and libraries for future use.</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Ensure the technical feasibility of UI/UX designs.</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>JavaScript frameworks, including jQuery & React.</p>
            </li>

            <li>
              <BiCheck className="service_list-icon" />
              <p>Proficient understanding of client-side scripting.</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>CSS pre-processing platforms, such as LESS and SASS.</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Optimize application for maximum speed and scalability.</p>
            </li>
          </ul>
        </article>
        <article className="service">
          <div className="service_head">
            <h3>Content Creation</h3>
          </div>
          <ul className="service_list">
            <li>
              <BiCheck className="service_list-icon" />
              <p>promote company initiatives.</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Using social media to engage consumers.</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Utilizing SEO methods to increase site traffic.</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>Writing, reviewing, editing, and updating content .</p>
            </li>
            <li>
              <BiCheck className="service_list-icon" />
              <p>
                company websites, blogs, marketing materials, and similar
                platforms.
              </p>
            </li>
          </ul>
        </article>
      </div>
    </section>
  );
};

export default Services;
